import { useState, useEffect } from "react";
import { Link ,useLocation} from "react-router-dom";
import logoMain from "../assets/hlogo11.png";
import logoScrolled from "../assets/hlogo22.png";
import { motion, AnimatePresence } from "framer-motion";
import Pop from "./PopupForm.jsx";
import {
  Menu,
  ChevronLeft,
  ChevronDown,
  Phone,
  Globe,
  Users,
  BookOpen,
  ClipboardCheck,
  CreditCard,
  FileText,
  Plane,
  Home,
  MapPin,
  ArrowRight,
} from "lucide-react";
import ReactCountryFlag from "react-country-flag";
const navItems = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  {
    name: "Our Services",
    href: "/services",
    submenu: [
      { name: "Door-to-Door Counselling", href: "/services/door-to-door-counselling", icon: Users },
      { name: "University Selection", href: "/services/university-selection", icon: Globe },
      { name: "Test Preparation", href: "/services/test-preparation", icon: BookOpen },
      { name: "Application Assistance", href: "/services/application-assistance", icon: ClipboardCheck },
      { name: "Financial Assistance", href: "/services/financial-assistance", icon: CreditCard },
      { name: "Visa Guidance", href: "/services/visa-guidance", icon: FileText },
      { name: "Pre-Departure Assistance", href: "/services/pre-departure-assistance", icon: Plane },
      { name: "Accommodation Assistance", href: "/services/accommodation-assistance", icon: Home },
      { name: "Post-Arrival Assistance", href: "/services/post-arrival-assistance", icon: MapPin },
    ],
  },
  {
  name: "Study Destinations",
  submenu: [
    { name: "UK", href: "/study/uk", countryCode: "GB" },
    { name: "Australia", href: "/study/australia", countryCode: "AU" },
    { name: "Canada", href: "/study/canada", countryCode: "CA" },
    { name: "Germany", href: "/study/germany", countryCode: "DE" },
    { name: "USA", href: "/study/usa", countryCode: "US" },
    { name: "New Zealand", href: "/study/newzealand", countryCode: "NZ" },
    { name: "Ireland", href: "/study/ireland", countryCode: "IE" },
    { name: "France", href: "/study/france", countryCode: "FR" },
  ],
},

  { name: "Blogs", href: "/blogs" },
  { name: "Contact", href: "/contact" },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [mobileDropdown, setMobileDropdown] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const location = useLocation();

  /* SCROLL */
  useEffect(() => {
    const onScroll = () => {
      if (window.innerWidth >= 1024) {
        setIsScrolled(window.scrollY > 40);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* BODY LOCK */
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* ================= HEADER ================= */}
      <motion.header
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className={`
          fixed top-0 inset-x-0 z-50 transition-all duration-500
          bg-gradient-to-r from-white/95 via-white/90 to-slate-100/90
          backdrop-blur-3xl shadow-[0_8px_30px_rgba(0,0,0,0.06)]
          border-b border-white/50
          ${
            isScrolled
              ? `
            lg:bg-gradient-to-r
            lg:from-[#1E3A8A]/75
            lg:via-[#2563EB]/70
            lg:to-[#1E40AF]/75
            lg:border-white/20
            lg:shadow-[0_14px_45px_rgba(30,64,175,0.45)]
          `
              : ""
          }
        `}
      >
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">

            {/* LOGO */}
            <Link to="/" className="flex items-center h-full">
              <motion.img
                key={isScrolled ? "logo-scrolled" : "logo-main"}
                src={isScrolled && window.innerWidth >= 1024 ? logoScrolled : logoMain}
                alt="Good Will Global Solutions"
                className="h-[78px] w-auto max-w-[320px] object-contain drop-shadow-lg"
              />
            </Link>

            {/* ================= DESKTOP NAV ================= */}
            <nav className="hidden lg:flex items-center gap-2">
              {navItems.map((item) => {
                const isOpen = activeSubmenu === item.name;
                 const isActive =
    location.pathname === item.href ||
    item.submenu?.some(sub =>
      location.pathname.startsWith(sub.href)
    );

                return (
                  <div
                    key={item.name}
                    className="relative group"
                    onMouseEnter={() => item.submenu && setActiveSubmenu(item.name)}
                    onMouseLeave={() => setActiveSubmenu(null)}
                  >
                    <Link
                      to={item.href}
                      className={`relative px-4 py-1.5 text-[13px] font-medium uppercase tracking-wide flex items-center gap-1 leading-none transition-colors
                        ${
                          isScrolled
                          ? isActive
                            ? "text-white/90 hover:text-white"
                            : "text-slate-800 hover:text-[#ffff]"
                           : isActive
                            ? "text-[#2F4DA6] font-semibold"
                            : "text-slate-800 hover:text-[#2F4DA6]"
                        }`}
                    >
                      {item.name}

                      {item.submenu && (
                        <motion.span
                          animate={{ rotate: isOpen ? 180 : 0 }}
                          transition={{ duration: 0.25 }}
                        >
                          <ChevronDown className="w-3.5 h-3.5 mt-[1px]" />
                        </motion.span>
                      )}

                      <span
  className={`absolute bottom-0 left-1/2 -translate-x-1/2
    h-[2px] transition-all duration-300
    ${
      isScrolled
        ? isActive
          ? "w-full bg-white"
          : "w-0 bg-white/80 group-hover:w-full"
        : isActive
        ? "w-full bg-[#5A74C9]"
        : "w-0 bg-[#5A74C9] group-hover:w-full"
    }`}
/>

                    </Link>

                    {/* DESKTOP SUBMENU */}
                    <AnimatePresence>
                      {item.submenu && isOpen && (
                        <motion.div
                          initial={{ opacity: 0, y: 10, scale: 0.96 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          exit={{ opacity: 0, y: 10, scale: 0.96 }}
                          transition={{ duration: 0.2 }}
                          className="absolute top-full mt-2 w-64 py-3 bg-white/95 backdrop-blur-xl rounded-xl border border-slate-200 shadow-xl"
                        >
                          {item.submenu.map((sub, i) => (
                            <motion.div
                              key={sub.name}
                              initial={{ opacity: 0, x: -8 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: i * 0.04 }}
                            >
                              <Link
                                to={sub.href}
                                className="flex items-center gap-3 px-4 py-2.5 text-slate-700 hover:text-[#253E90] hover:bg-[#5A74C9]/10 transition"
                              >
                                {sub.countryCode ? (
  <ReactCountryFlag
    svg
    countryCode={sub.countryCode}
    style={{ width: "1.2em", height: "1.2em" }}
  />
) : (
  <sub.icon className="w-4 h-4 text-[#5A74C9]" />
)}

                                {sub.name}
                              </Link>
                            </motion.div>
                          ))}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
            </nav>

            {/* CTA */}
            <button
              onClick={() => setShowForm(true)}
              className={`hidden lg:flex items-center gap-2 px-6 py-3 rounded-full text-sm transition
                ${isScrolled ? "bg-white/20 backdrop-blur-md text-white" : "bg-[#2F4DA6] text-white"}`}
            >
              <Phone className="w-4 h-4" />
              Door Step Counselling
            </button>

            {/* MOBILE TOGGLE */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-11 h-11 rounded-lg flex items-center justify-center bg-white/70 text-[#253E90]"
            >
              {isMobileMenuOpen ? <ChevronLeft /> : <Menu />}
            </button>
          </div>
        </div>
      </motion.header>

      {/* ================= MOBILE SIDEBAR ================= */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div className="fixed inset-0 z-40 lg:hidden" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <div className="absolute inset-0 bg-black/40" onClick={() => setIsMobileMenuOpen(false)} />

            <motion.div
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
              className="absolute right-0 top-0 bottom-0 w-80 backdrop-blur-2xl bg-gradient-to-b from-white/95 via-white/90 to-slate-100/95"
            >
              <div className="p-6 pt-24">
                {navItems.map((item) => {
                  const isOpen = mobileDropdown === item.name;

                  return (
                    <div key={item.name} className="mb-6">

                      {/* MAIN ROW */}
                      {/* MAIN ROW */}
<div className="flex items-center justify-between w-full text-slate-800">

  <Link
    to={item.href}
    onClick={() => !item.submenu && setIsMobileMenuOpen(false)}
    className="flex-1"
  >
    {item.name}
  </Link>

  <div className="flex items-center gap-2">

    {/* RIGHT ICON FOR NORMAL LINKS */}
    {!item.submenu && (
      <ArrowRight className="w-4 h-4 text-[#2F4DA6]" />
    )}

    {/* DROPDOWN ICON FOR SERVICES / DESTINATIONS */}
    {item.submenu && (
      <button
        onClick={() => setMobileDropdown(isOpen ? null : item.name)}
        className="ml-1 flex items-center justify-center w-7 h-7 rounded-md hover:bg-[#2F4DA6]/10 text-[#2F4DA6]"
      >
        <ChevronDown
          className={`w-4 h-4 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>
    )}

  </div>
</div>


                      {/* MOBILE SUBMENU */}
                      {item.submenu && isOpen && (
                        <div className="ml-4 mt-3 border-l border-slate-300">
                          {item.submenu.map((sub) => (
                            <Link
                              key={sub.name}
                              to={sub.href}
                              onClick={() => setIsMobileMenuOpen(false)}
                              className="flex items-center gap-3 px-4 py-2 text-slate-600"
                            >
                              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#2F4DA6]/15 to-[#5A74C9]/20 flex items-center justify-center">
                                {sub.countryCode ? (
  <ReactCountryFlag
    svg
    countryCode={sub.countryCode}
    style={{ width: "1.2em", height: "1.2em" }}
  />
) : (
  <sub.icon className="w-4 h-4 text-[#2F4DA6]" />
)}

                              </div>
                              {sub.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}

                {/* MOBILE CTA */}
                <button
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    setShowForm(true);
                  }}
                  className="mt-10 flex items-center justify-center gap-2 w-full px-6 py-4 bg-[#2F4DA6] text-white rounded-xl"
                >
                  <Phone className="w-4 h-4" />
                  Door Step Counselling
                </button>

              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <Pop show={showForm} onClose={() => setShowForm(false)} />
    </>
  );
}
